import styled from "styled-components";
import { Switch } from "./Switch";

export const SwitchCard = ({icon, title, description = null, isChecked, onChange}) => {

    return (
        <StyledSwitchCard $isChecked={isChecked}>
            <div className="switchCardHeader">
                <div className="iconContainer">
                    {icon}
                </div>
                <div className="switchContainer">
                    <Switch
                        isChecked={isChecked}
                        onChange={(e) => onChange(e.target.checked)}
                    />
                </div>
            </div>
            <div className="switchCardContent">
                <div className="switchCardTitle">{title}</div>
                {description ? <div className="switchCardDescription">{description}</div> : null} 
            </div>
        </StyledSwitchCard>
    )
}

const StyledSwitchCard = styled.label`
    display: flex;
    flex-direction: column;
    padding: ${({theme}) => theme.spacing.lg};
    cursor: pointer;
    user-select: none;
    gap: ${({theme}) => theme.spacing.md};
    border: 1px solid ${({theme, $isChecked}) => $isChecked ? theme.colors.neutralSecondaryForeground : theme.colors.neutralPrimaryBorder};
    border-radius: ${({theme}) => theme.cornerRadius.md};
    flex: 1 0 250px;
    min-width: 250px;

    div.switchCardHeader
    {
        display: inline-flex;
        justify-content: space-between;

        div.iconContainer
        {
            width: 38px;
            height: 38px;
            //border: 1px solid ${({$isChecked}) => $isChecked ? 'red' : 'black'};
            background: ${({theme, $isChecked}) => $isChecked ? theme.colors.neutralSecondaryForeground : theme.colors.mutedForeground};
            display: flex;
            align-items: center;
            justify-content: center;
            flex: 0 0 38px;
            border-radius: ${({theme}) => theme.cornerRadius.sm};
            transition-duration: 110ms;
            color: ${({theme}) => theme.colors.neutralPrimaryBackground};

            .icon
            {
                font-size: ${({theme}) => theme.iconSize.lg};
            }
        }
    }

    div.switchCardContent
    {

        color: ${({theme, $isChecked}) => $isChecked ? theme.colors.neutralSecondaryForeground : theme.colors.mutedForeground};
        display: flex;
        flex-direction: column;
        gap: ${({theme}) => theme.spacing.md};

        div.switchCardTitle
        {
            font-weight: 600;
        }

    }

`